export default __webpack_public_path__ + "images/wall_glass_0ddc3860b525d7c61eee7b899efb2550.png";